import React, { Component } from 'react';

import ConfirmDeleteButton from '../../../Common/Buttons/ConfirmDeleteButton';
import isPresent from '../../../Common/Utils/Present';

type Props = {
  expandIcon: any,
  fields: any,
  handleRemove: any,
  handleTouchTap: any,
  record: any,
  slotIndex: number
};

class SlotHead extends Component<Props> {
  render() {
    let name = null;

    if (isPresent(this.props.record && this.props.record.slots && this.props.record.slots[this.props.slotIndex])) {
      if (this.props.record.slots[this.props.slotIndex].name) {
        name = <span style={{ paddingLeft: 10 }}>
          {this.props.record.slots[this.props.slotIndex].name}
        </span>;
      }
    } else {
      name = <span style={{ paddingLeft: 10 }}>New Slot</span>;
    }

    return (
      <div>
        <div onClick={() => this.props.handleTouchTap(this.props.slotIndex)} style={{ cursor: 'pointer', backgroundColor: '#f5f5f5', padding: 15 }}>
          {name}
          <span style={{ paddingLeft: 10 }}>{this.props.expandIcon}</span>

          <div style={{ float: 'right' }}>
            <ConfirmDeleteButton onClick={(event) => this.props.handleRemove(event, this.props.slotIndex)} />
          </div>
        </div>
      </div>
    )
  }
};

export default SlotHead;



// WEBPACK FOOTER //
// ./src/views/Components/Placements/Partials/SlotHead.tsx